import { Reveal } from "@/lib/motion";

export default function FounderNote() {
  return (
    <section
      data-testid="founder-section"
      className="py-20 md:py-28 border-y border-ink/10 bg-bg-muted relative overflow-hidden"
    >
      <div className="absolute inset-0 paper-grain pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <Reveal className="lg:col-span-4">
            <div className="overline">Founder-led</div>
            <div className="mt-8 aspect-[4/3] bg-ink relative overflow-hidden max-w-md">
              <img
                src="https://images.unsplash.com/photo-1517842645767-c639042777db?w=1000&q=80&auto=format&fit=crop"
                alt="Notebook, pen and coffee on a working desk"
                className="absolute inset-0 w-full h-full object-cover opacity-95"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 text-bg-base">
                <div className="overline text-bg-base/60">Based in</div>
                <div className="font-serif-display text-2xl mt-2">
                  Sydney, NSW
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7 lg:col-start-6" delay={1}>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Built from real-world business, marketing,
              administration and systems experience —
              <em className="font-light text-ink-soft">
                {" "}
                not theory, not slideware.
              </em>
            </h2>
            <p className="mt-8 text-lg leading-relaxed text-ink/75 max-w-2xl">
              ETradingGroup is founder-led and grounded in years of operating
              across corporate administration, marketing communications,
              research and analytics, business support, operations, technology
              adoption and practical AI implementation. We work with you the
              same way we'd work on our own business: pragmatic, structured,
              and quietly ambitious.
            </p>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-6 max-w-2xl">
              {[
                ["Corporate", "administration"],
                ["Marketing", "communications"],
                ["Research", "& analytics"],
                ["Operations", "& workflow"],
                ["Technology", "adoption"],
                ["Practical AI", "implementation"],
              ].map(([a, b]) => (
                <div key={a + b} className="text-[13.5px] leading-tight">
                  <div className="text-ink font-medium">{a}</div>
                  <div className="text-ink-soft">{b}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
